// src/pages/CreateEssens/Summary.js
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { lagreKodeEssens } from '../../utils/essensStorage';

function Summary() {
  const location = useLocation();
  const navigate = useNavigate();
  const [essens, setEssens] = useState(null);
  const [status, setStatus] = useState('');

  useEffect(() => {
    if (location.state) {
      setEssens(location.state);
    }
  }, [location.state]);

  const handleSave = async () => {
    setStatus('Lagrer...');
    try {
      await lagreKodeEssens(essens);
      setStatus('✅ Lagret!');
      setTimeout(() => navigate('/myessence'), 1500);
    } catch (error) {
      console.error('❌ Feil ved lagring:', error);
      setStatus('❌ Feil ved lagring');
    }
  };

  if (!essens) {
    return <div style={styles.message}>❌ Ingen data funnet.</div>;
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Oppsummering av din Kode-Essens™</h1>
      <div style={styles.card}>
        <p><strong>Kodeord:</strong> {essens.kodeord}</p>
        <p><strong>Kjennetegn:</strong> {essens.kjennetegn}</p>
        <p><strong>Essens-setning:</strong> {essens.essensSetning}</p>
        <p><strong>Tilkallingsformel:</strong> {essens.tilkallingsformel}</p>
      </div>
      <button style={styles.button} onClick={handleSave}>
        Bekreft og Lagre Kode-Essens™
      </button>
      {status && <p style={styles.status}>{status}</p>}
    </div>
  );
}

const styles = {
  container: {
    padding: '2rem',
    color: 'white',
    minHeight: '100vh',
    backgroundColor: '#111',
    textAlign: 'center'
  },
  title: {
    fontSize: '2rem',
    marginBottom: '1.5rem'
  },
  card: {
    backgroundColor: '#222',
    padding: '1.5rem',
    borderRadius: '1rem',
    marginBottom: '1.5rem',
    textAlign: 'left',
    maxWidth: '600px',
    marginInline: 'auto'
  },
  button: {
    backgroundColor: '#3b82f6',
    color: 'white',
    padding: '0.75rem 1.5rem',
    border: 'none',
    borderRadius: '0.5rem',
    cursor: 'pointer',
    fontSize: '1rem'
  },
  status: {
    marginTop: '1rem',
    color: '#38bdf8'
  },
  message: {
    textAlign: 'center',
    padding: '4rem',
    color: 'red'
  }
};

export default Summary;
